export const UPDATE_COMPONENT_STATE_MUTATION = 'update_component_state';

export const CHANGE_SELECTED_ANSWER_TO_ID_MUTATION = 'change_selected_answer_to_id';

export const PREPARE_COMMENT_FOR_EDITING_MUTATION = 'prepare_comment_for_editing';

export const CANCEL_COMMENT_EDITING_MUTATION = 'cancel_comment_editing';

export const CHANGE_COMMENT_TEXT_AFTER_UPDATE_MUTATION = 'change_comment_text_after_update';

export const CHANGE_COMMENT_LIKE_MUTATION = 'change_comment_like';

export const CHANGE_COMMENT_STATUS_MUTATION = 'change_comment_status';

export const SHOW_MODAL_MUTATION = 'show_modal';

export const HIDE_MODAL_MUTATION = 'hide_modal';

export const CHANGE_HIGHLIGHT_COMMENT_ID_MUTATION = 'change_highlight_comment_id';

export const REMOVE_HIGHLIGHT_OF_COMMENT_ID_MUTATION = 'remove_highlight_of_comment_id';

export const UPDATE_COMPONENT_STATE_AFTER_COMMENT_CREATING_MUTATION = 'update_component_state_after_comment_creating_mutation';

export const CHANGE_CURRENT_MATERIAL_ID_MUTATION = 'change_current_material_id_mutation';
